
    import __i18nConfig from '@next-translate-root/i18n.json'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import Head from 'next/head';
import clsxm from '@/lib/clsxm';
import AboutFinalCta from '@/components/about/AboutFinalCta';
import AboutFounders from '@/components/about/AboutFounders';
import AboutHero from '@/components/about/AboutHero';
import AboutStory from '@/components/about/AboutStory';
import AboutValues from '@/components/about/AboutValues';
import AboutWorkshops from '@/components/about/AboutWorkshops';
import { useAboutTranslation } from '@/components/about/kit';
import { tone } from '@/components/agents/primitives';
import Footer from '@/components/layout/Footer';
import Seo from '@/components/Seo';
import { ORGANIZATION_SAME_AS } from '@/components/StructuredData';
// The page describes the company, so it carries an AboutPage/Organization
// schema instead of the site's generic product schema.
const ABOUT_JSON_LD = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    url: 'https://easy-peasy.ai/about-us',
    name: 'About Easy-Peasy.AI',
    mainEntity: {
        '@type': 'Organization',
        name: 'Easy-Peasy.AI',
        legalName: 'Easy-Peasy.AI Pte. Ltd.',
        url: 'https://easy-peasy.ai',
        logo: 'https://easy-peasy.ai/images/big-logo.png',
        foundingDate: '2022',
        address: { '@type': 'PostalAddress', addressCountry: 'SG' },
        founder: [
            {
                '@type': 'Person',
                name: 'Marianna Olefyrenko',
                jobTitle: 'CEO and Co-Founder',
            },
            {
                '@type': 'Person',
                name: 'Dmytro Olefyrenko',
                jobTitle: 'CTO and Co-Founder',
            },
        ],
        award: [
            'ASEAN Startup Awards 2024: Best Web 3.0/AI Startup (Singapore)',
            'Global Startup Awards 2024: global finalist',
            'Singapore SME 500 Award 2024',
            'Brands For Good Awards 2025: Honouree, Technology for Good',
            'Brands For Good Awards 2026: Tech For Good Honouree',
        ],
        sameAs: ORGANIZATION_SAME_AS,
    },
};
/*
 * The company page (linked as "About Us"): the founders' story, the
 * milestones and awards since 2022, how we work, and our workshops.
 */
export default function AboutUs() {
    const { t, lang } = useAboutTranslation();
    return (
    // `relative` makes <main> the containing block of the footer's sr-only
    // heading, so overflow-x-clip catches the 1px it pokes out in RTL. Korean
    // wraps between words (keep-all), not inside them.
    <main className={clsxm('relative overflow-x-clip [&:lang(ko)]:break-keep', tone.page)} dir={lang === 'ar' ? 'rtl' : undefined}>
      <Seo templateTitle={t('About Us: Our Story and Founders')} description={t('Easy-Peasy.AI is an AI platform built in Singapore by Marianna and Dmytro Olefyrenko, used by 3.4M+ people in 150+ countries. Our story, awards and values.')} image={`https://easy-peasy.ai/api/og-template?title=${encodeURIComponent(t('Making AI easy-peasy for everyone'))}`} structuredData={false}/>
      <Head>
        <script type='application/ld+json' 
    // Static, server-built JSON: nothing user-supplied goes in here.
    dangerouslySetInnerHTML={{ __html: JSON.stringify(ABOUT_JSON_LD) }}/>
      </Head>
      <AboutHero />
      <AboutStory />
      <AboutFounders />
      <AboutValues />
      <AboutWorkshops />
      <AboutFinalCta />
      <Footer />
    </main>);
}

    async function __Next_Translate__getStaticProps__1a11b03d555__(ctx) {
      if (typeof global !== 'undefined') {
        global.i18nConfig = __i18nConfig
      }
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/about-us',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import('../../locales/' + l + '/' + n).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a11b03d555__ as getStaticProps }
  